import React, { useState } from "react";

const Email = ({
  buttonText = "",
  handleSubmit = () => {},
  loading = false,
  componentClassName = "",
  inputClassName = "",
  buttonClassName = "",
  onFocus = () => {},
  onBlur = () => {},
  buttonStyle = {},
  inputStyle = {},
}) => {
  const [email, setEmail] = useState("");
  return (
    <div
      className={`w-full flex justify-center items-center ${componentClassName}`}
    >
      <input
        data-testid="email-input"
        style={{ WebkitUserSelect: "auto", paddingRight: 0, minWidth: "20rem", ...inputStyle }}
        className={`p-2 w-full outline-none ${inputClassName}`}
        placeholder="Enter your email"
        disabled={loading}
        onChange={(e) => {
          setEmail((e.target.value.trim() || "").toLowerCase());
        }}
        value={email}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            e.currentTarget.focus();
            handleSubmit(email);
          }
        }}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      <button
        data-testid="email-submit"
        type="button"
        className={`whitespace-nowrap px-4 py-2 focus:outline-none ${buttonClassName}`}
        style={buttonStyle}
        onClick={() => handleSubmit(email)}
      >
        {buttonText}
      </button>
    </div>
  );
};

export default Email;
